import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { useLoanActionsControls } from '../../../hooks/useLoanActionsControls';
import LoanActionRunnerDrawers from '../../../LoanActionRunnerDrawers';
import { DEFAULT_LOAN_ACTION_RUN_STATE } from '../../LoanActionRunnerProvider.constants';

const LoanActionRunnerEngine = ({
  actionSource,
  executor,
  onRunStateChange,
  runnerContext = null,
  onAfterExecute = null,
  onClientOnlyLaunch = null,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    executingActionId,
    isDataLoaded,
    onLoanActionClick,
    disabledLoanActionsSet,
    loanEditorCustomFormDrawerState,
    onCloseLoanEditorCustomFormDrawer,
    iframeDrawerState,
    onCloseIframeDrawer,
    worksheetDrawerState,
    onCloseWorksheetDrawer,
    mersPreviewDrawerState,
    onCloseMersPreviewDrawer,
  } = useLoanActionsControls(setIsLoading, {
    actionSource,
    executor,
    runnerContext,
    onAfterExecute,
    onClientOnlyLaunch,
  });

  useEffect(() => {
    onRunStateChange({
      isLoading,
      isDataLoaded,
      executingActionId,
      disabledLoanActionsSet,
      onLoanActionClick,
    });
  }, [
    disabledLoanActionsSet,
    executingActionId,
    isDataLoaded,
    isLoading,
    onLoanActionClick,
    onRunStateChange,
  ]);

  useEffect(() => () => onRunStateChange(DEFAULT_LOAN_ACTION_RUN_STATE), [onRunStateChange]);

  return (
    <LoanActionRunnerDrawers
      iframeDrawerState={iframeDrawerState}
      loanEditorCustomFormDrawerState={loanEditorCustomFormDrawerState}
      mersPreviewDrawerState={mersPreviewDrawerState}
      worksheetDrawerState={worksheetDrawerState}
      onCloseIframeDrawer={onCloseIframeDrawer}
      onCloseLoanEditorCustomFormDrawer={onCloseLoanEditorCustomFormDrawer}
      onCloseMersPreviewDrawer={onCloseMersPreviewDrawer}
      onCloseWorksheetDrawer={onCloseWorksheetDrawer}
    />
  );
};

LoanActionRunnerEngine.propTypes = {
  actionSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  executor: PropTypes.func.isRequired,
  onRunStateChange: PropTypes.func.isRequired,
  runnerContext: PropTypes.object,
  onAfterExecute: PropTypes.func,
  onClientOnlyLaunch: PropTypes.func,
};

export default LoanActionRunnerEngine;
